export default "__VITE_ASSET__D4m7Veat__"